export const VEHICLE_SELECTION_DROPDOWNS = {
    list: ["make","model","year","size", "wheels"],
    is_after: function(a, b){
        return this.list.indexOf(b) > this.list.indexOf(a)
    },
    after: function(value) {
        let current_index = this.list.indexOf(value)
        let max_index = this.list.length - 1
        if(current_index === max_index ){
            return this.list[max_index]
        }else{
            return this.list[current_index + 1]
        }
    },
    forEachAfter: function(value, func)  {
        let current_index = this.list.indexOf(value)
        this.list.forEach( (dropdown, index, arr) => {
            if( index > current_index && index !== current_index ){
                func(dropdown, index)
            }
        })
    },
    isNotLast: function(value){
       return value !== this.list[this.length -  1]
    }
}